import AbstractFormulaNode from "./AbstractFormulaNode.js";

/**
 * Formula node representing the number of days in the current
 * period.
 */
export default class NumberOfDaysInPeriodNode extends AbstractFormulaNode {
	static getType() {
		return "NumberOfDaysInPeriod";
	}
}
